import { DefaultOffice, DistrictDropdownOption } from "../utils/enums";

export const App = {
  isAuth: false,
  smtp: {
    id: -1,
    host: "",
    login: "",
    password: "",
    port: 0,
    sslEnabled: false,
  },
  permissions: [],
  roles: [],
  layoutPermissions: [],
  loggedUser: {
    isAdmin: false,
    isSysAdmin: false,
    officePermissions: [],
    loginName: "",
    userId: null,
    officeId: null,
    districtId: DistrictDropdownOption.NotSetted,
    isCitizen: false,
    aswAccountId: null,
    aswMainProfileId: null,
  },
  offices: [],
  defaultOffice: { id: DefaultOffice.NotSetted },
  thematicAreas: [],
  projectModes: [],
  commentingModes: [],
  projectStatuses: [],
  moderators: [],
  projectTypes: [],
  searchList: [],
  totalSearchListItems: 0,
  mainPageProjects: [],
  externalSystemAddress: "",
  officeFooter: {
    name: "",
    street: "",
    number: "",
    flat: "",
    postCode: "",
    city: "",
    phone: "",
    fax: "",
    bip: "",
    www: "",
    eboi: "",
    officeOpenHours: "",
  },
  initiativeConfiguration: {
    mode: 0,
  },
  districts: [],
  availableBudgetYears: [],
  mapConfiguration: {
    zoom: 13,
    latitude: 19,
    longitude: 52,
  },
  reCaptchaConfiguration: null,
  termsOfUse: null,
  isSearching: false,
  isLoging: false,
  pageSize: 10,
  archivePageSize: 10,
  applicationImages: null,
  mainPageProbeProjects: [],
  expand: {
    budgets: [],
    oldbudgets: [],
    consultations: [],
    oldconsultations: [],
    surveys: [],
    oldsurveys: [],
    probes: [],
    oldprobes: [],
  },
  breadcrumbs: [],
  streetFeatures: [],
  appVersion: "1.0.0",
  appModuleFetched: false,
  serverIdentity: null,
  topMenuElements: [],
  tiles: [],
};
